import React from 'react';
import './ChatToggleButton.css';

interface ChatToggleButtonProps {
  isOpen: boolean;
  onToggle: () => void;
}

const ChatToggleButton: React.FC<ChatToggleButtonProps> = ({ isOpen, onToggle }) => {
  return (
    <button 
      className={`chat-toggle-button ${isOpen ? 'active' : ''}`}
      onClick={onToggle}
      title={isOpen ? 'Close Chat' : 'Open Chat'}
    >
      <svg 
        className={`chat-arrow-icon ${isOpen ? 'rotated' : ''}`}
        fill="#ffffff" 
        viewBox="0 0 200 200" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M100,15a85,85,0,1,0,85,85A84.93,84.93,0,0,0,100,15Zm0,150a65,65,0,1,1,65-65A64.87,64.87,0,0,1,100,165ZM97.5,57.5a9.9,9.9,0,0,0-14,14L112,100,83.5,128.5a9.9,9.9,0,0,0,14,14L126,114a19.92,19.92,0,0,0,0-28.5Z"></path>
      </svg>
    </button>
  );
};

export default ChatToggleButton;